import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
  
import { hasPlatformEnableAnalyticsEnabled } from '../../utils/flags';
import { GlobalPageTracker } from './global-page-tracker';
import { tracker } from '../../core/defaults';
  
/**
 * Functional component which enables/disables the tracker depending on the
 * PlatformEnableAnalytics feature flag.
 * It also renders the GlobalPageTracker component in case of the analytics service
 * is enabled.
 */
export const GlobalTracker: React.FC = () => {
  const flags = useFlags();
  const isAnalyticsEnabled = hasPlatformEnableAnalyticsEnabled(flags);

  React.useEffect(() => {
    isAnalyticsEnabled ? tracker.enable() : tracker.disable();
  }, [isAnalyticsEnabled]);

  if (!isAnalyticsEnabled) {
    return null;
  }

  return <GlobalPageTracker />;
};
  
